import gql from "graphql-tag";

export default gql`
    query {
        __type(name: "Currency") {
            name
            enumValues {
                name
                description
            }
        }
    }
`;
